export const FETCH_AGENT_REQUEST = 'FETCH_AGENT_REQUEST';
export const FETCH_AGENT_SUCCESS = 'FETCH_AGENT_SUCCESS';
export const FETCH_AGENT_FAILURE = 'FETCH_AGENT_FAILURE';

export const SEARCH_AGENT_REQUEST = 'SEARCH_AGENT_REQUEST';
export const SEARCH_AGENT_SUCCESS = 'SEARCH_AGENT_SUCCESS';
export const SEARCH_AGENT_FAILURE = 'SEARCH_AGENT_FAILURE';

